import React, { useEffect, useState } from "react";
import {
  Container,
  Title,
  CloseButton,
  Buttons,
  SpecialContent,
  SpecialTitle,
  SpecialDescription,
  SpecialTitleWrapper,
} from "./index.styled";
import Button from "../button/index";
import axios from "axios";
import "./newleasing.css";
import BlackDollarIcon from "images/dollar_white.svg";

const NewLeasing = ({
  isFirstLoad,
  isFirstLeasing,
  data,
  setIsFirstLeasing = () => {},
}) => {
  const [show, setShow] = useState(false);
  const [specialsData, setSpecialsData] = React.useState([]);
  const [fpSpecialList, setFpSpecialList] = React.useState([]);
  const [containerHeight, setContainerHeight] = useState(0);
  const containerRef = React.useRef(null);

  const onClose = () => {
    setShow(false);

    setTimeout(() => {
      setIsFirstLeasing(false);
    }, 1000);
  };

  const onScroll = () => {
    window.scrollY === 0 ? setShow(true) : setShow(false);
  };
  useEffect(() => {
    if (document) {
      document.addEventListener("scroll", onScroll);
    }
  }, []);

  useEffect(() => {
    if (isFirstLoad) {
      setTimeout(() => {
        setShow(true);
      }, 4000);
    } else if (isFirstLeasing) {
      setShow(true);
    }
  }, [isFirstLoad, isFirstLeasing]);

  React.useEffect(() => {
    fetchSpecialsData();
  }, []);

  // Calculate container height when component mounts or data changes
  React.useEffect(() => {
    if (containerRef.current && specialsData) {
      const height = containerRef.current.scrollHeight;
      setContainerHeight(height);
    }
  }, [specialsData, show]);

  const fetchSpecialsData = async () => {
    try {
      // const bearerToken = process.env.GATSBY_TOKEN;

      const response = await axios.get(
        `${process.env.STRAPI_URL}/api/specials`,
        {
          headers: {
            // Authorization: `Bearer ${bearerToken}`,
          },
        }
      );

      setSpecialsData(response?.data?.data[0]?.attributes?.propertySpecials);
      setFpSpecialList(
        response?.data?.data[0]?.attributes?.floorplanSpecials?.floorplans
          ?.floorplan
      );
    } catch (error) {
      console.error(
        `Error fetching data: ${
          error.response ? error.response.data : error.message
        }`
      );
    }
  };

  return (
    <>
      {specialsData && (
        <Container
          ref={containerRef}
          className={show && "show"}
          style={{
            "--container-height": `${containerHeight}px`,
            marginTop: show ? 0 : `-${containerHeight}px`,
          }}
        >
          <SpecialContent>
            <CloseButton onClick={onClose} />
            <SpecialTitleWrapper>
              <SpecialTitle
                dangerouslySetInnerHTML={{ __html: specialsData?.name }}
              />
            </SpecialTitleWrapper>
            <SpecialDescription>
              <Title>
                {fpSpecialList?.length > 0 && (
                  <img
                    id="dollarIconToShow"
                    style={{ marginRight: 10 + "px" }}
                    src={BlackDollarIcon}
                    width="22px"
                    height="22px"
                    alt="special icon"
                  />
                )}
                {specialsData?.description}
                {/* <span>
                *Restrictions may apply. See leasing team for details.
            </span> */}
              </Title>
              <Buttons>
                {/* <ScheduleTour className={'white beige'} /> */}
                <Button
                  to={"#"}
                  title={"Schedule a Tour"}
                  className={"white beige hytour-link"}
                  onClick={onClose}
                  El="a"
                  // target={"_blank"}
                />
              </Buttons>
            </SpecialDescription>
          </SpecialContent>
        </Container>
      )}
    </>
  );
};

export default NewLeasing;
